<!-- 试卷-题目列表 -->
<template>
  <div>
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item :to="{ path: '/home' }">首页</el-breadcrumb-item>
      <el-breadcrumb-item>学术系统</el-breadcrumb-item>
      <el-breadcrumb-item>试卷管理</el-breadcrumb-item>
    </el-breadcrumb>
    <el-page-header @back="goBack"></el-page-header>
    <el-card style="margin-top: 15px">
      <div class="title">
        <div class="title_class">{{ typeStr }}</div>
        <el-button type="primary" plain @click="showDialogIntro()">题型介绍</el-button>
      </div>
      <el-row class="title_row" align="middle" type="flex">
        <el-col :span="12">
          <span><span class="formName">{{ formName }}</span> 试题详情<i class="refresh el-icon-refresh" @click="getList()"></i></span>
        </el-col>
        <!-- <el-col :span="12" style="text-align: right;">
          <el-button type="primary" @click="showDialog(null)"
            >新建试卷</el-button
          >
        </el-col> -->
      </el-row>
      <!-- 列表表格区域 -->
      <el-table
        header-cell-class-name="tableHeaderStyle"
        :data="dataList"
        border
        stripe
      >
        <el-table-column label="序号" type="index"></el-table-column>
        <el-table-column label="题号" prop="quizNumber">
          <template slot-scope="scope">
            {{ scope.row.isStandby ? '备用' : '' }}{{ scope.row.quizNumber }}
          </template>
        </el-table-column>
        <el-table-column v-if="type === 1" label="题目类型" prop="quizForm">
          <template slot-scope="scope">
            <el-tag size="mini" :effect="scope.row.quizForm === 1 ? 'dark' : 'light'">{{ scope.row.quizForm === 1 ? '例题' : '试题' }}</el-tag>
          </template>
        </el-table-column>
        <el-table-column label="题型" prop="quizType">
          <template slot-scope="scope">
            <el-tag :type="scope.row.quizType === 1 ? 'warning' : scope.row.quizType === 2 ? 'success' : 'danger'">
              {{ scope.row.quizTypeStr }}
            </el-tag>
          </template>
        </el-table-column>
        <el-table-column label="题目" prop="question" v-if="type === 3"></el-table-column>
        <el-table-column label="录音" prop="audioUrl" width="180px" v-if="type === 1">
          <template slot-scope="scope">
            <div style="display: flex; align-items: center; justify-content: center; width: 100%;">
              <div>
                <el-button v-if="scope.row.audioUrl" type="primary" plain class="play-audio" @click="controlFn(scope.row.audioUrl)">
                  <i class="iconfont icon-yinpinaudio47"></i>
                </el-button>
                <el-tooltip v-if="scope.row.quizDescription" class="item" effect="dark" :content="scope.row.quizDescription" placement="top-start">
                  <el-button type="primary" plain size="small">录音</el-button>
                </el-tooltip>
              </div>
              <!-- 题型为4时，在录音按钮右侧展示图片缩略图 -->
              <img
                v-if="scope.row.quizType === 4 && scope.row.imgUrl"
                :src="scope.row.imgUrl"
                class="quiz-img-thumb"
                style="margin-left: 30px;"
                @click="handlePreviewImg(scope.row.imgUrl)"
              >
            </div>
          </template>
        </el-table-column>
        <el-table-column label="拼音发音" prop="pinyinUrl" v-if="type === 3">
          <template slot-scope="scope">
            <el-button v-if="scope.row.pinyinUrl" type="primary" plain class="play-audio" @click="controlFn(scope.row.pinyinUrl)">
              <i class="iconfont icon-yinpinaudio47"></i>
            </el-button>
          </template>
        </el-table-column>
        <el-table-column label="定义发音" prop="definitionUrl" v-if="type === 3">
          <template slot-scope="scope">
            <el-button type="primary" plain class="play-audio" @click="controlFn(scope.row.definitionUrl)">
              <i class="iconfont icon-yinpinaudio47"></i>
            </el-button>
          </template>
        </el-table-column>
        <el-table-column label="例句发音" prop="sentenceUrl" v-if="type === 3">
          <template slot-scope="scope">
            <el-button type="primary" plain class="play-audio" @click="controlFn(scope.row.sentenceUrl)">
              <i class="iconfont icon-yinpinaudio47"></i>
            </el-button>
          </template>
        </el-table-column>
        <el-table-column label="选项" prop="choice" :width="type === 3 ? 160 : 260">
          <template slot-scope="scope">
            <template v-if="scope.row.choiceType === 2">
              <span class="choice-text" v-for="(font, index) of scope.row.choiceList" :key="index">{{ font }}</span>
            </template>
            <template v-else>
              <div class="choice-img" v-for="(img, index) of scope.row.choiceList" :key="index">
                <img :src="img" alt="">
              </div>
            </template>
          </template>
        </el-table-column>
        <el-table-column label="答案" prop="answer">
          <template slot-scope="scope">
            <div style="display: flex; align-items: center;">
              <div v-for="(a, aIndex) of scope.row.answerList" :key="aIndex">
                <div class="choice-img" v-if="a.length > 5">
                  <img :src="a" class=""/>
                </div>
                <span v-else class="choice-text">{{ a }}</span>
              </div>
            </div>
          </template>
        </el-table-column>
        <el-table-column label="分数" prop="questionScore"></el-table-column>
        <el-table-column label="时间/秒" prop="questionTime" v-if="type === 3"></el-table-column>
        <el-table-column label="操作" v-if="type === 1">
          <template slot-scope="scope">
            <el-button
              type="text"
              size="mini"
              icon="el-icon-edit"
              @click="handleToEdit(scope.row)"
            >修改</el-button>
          </template>
        </el-table-column>
      </el-table>
      <!-- 分页区域 -->
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="queryForm.pageNum"
        :page-sizes="[30, 40, 50]"
        :page-size="queryForm.pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total"
      >
      </el-pagination>
    </el-card>
    <!-- 录音播放 -->
    <audio ref="audioPlayer" @ended="pause"></audio>

    <!-- 图片预览 -->
    <el-dialog
      title="图片预览"
      :visible.sync="previewImgVisible"
      width="400px"
      :close-on-click-modal="true"
    >
      <div style="text-align: center;">
        <img :src="previewImgUrl" class="quiz-img-preview" v-if="previewImgUrl">
      </div>
    </el-dialog>

    <!-- 修改题目 -->
    <el-dialog
      title="修改题目"
      :visible.sync="editVisible"
      :width="isImgOption ? '1000px' : '500px'"
      :close-on-click-modal="false"
      >
        <el-form
          :model="editForm"
          :rules="editFormRules"
          label-width="110px"
          ref="editFormRef"
        >
          <el-row>
            <el-col :span="22">
              <el-form-item label="题号" prop="quizNumber">
                <el-input
                  v-model="editForm.quizNumber"
                  placeholder="请输入"
                  clearable
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="isImgOption ? 24 : 22">
              <el-form-item label="选项" prop="choice">
                <template v-if="isImgOption">
                  <div class="choice-img" @click="clickChoiceFn(item, index)" v-for="(item, index) of choiceList" :key="item">
                    <img :src="item" alt="">
                  </div>
                </template>
                <span v-else @click="clickChoiceFn(item, index)" class="choice-text choice-item" v-for="(item, index) of choiceList" :key="item">{{ item }}</span>
                <el-input
                  v-model="editChoiceItem"
                  placeholder="请输入"
                  :style="{width: isImgOption ? '86%' : '76%'}"
                ></el-input>
                <el-button type="primary" @click="changeChoiceFn">确定</el-button>
                <div class="tip-text">1.点击待修改选项进行修改；2.点击确定</div>
              </el-form-item>
            </el-col>
            <el-col :span="22">
              <el-form-item label="答案" prop="answer">
                <div class="choice-img" v-if="isImgOption">
                  <img :src="editForm.answer" alt="">
                </div>
                <el-input
                  v-model="editForm.answer"
                  placeholder="请输入"
                  clearable
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="22">
              <el-form-item label="分数" prop="questionScore">
                <el-input
                  v-model="editForm.questionScore"
                  placeholder="请输入"
                  clearable
                ></el-input>
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
      <div class="footer">
        <el-button @click="handleCloseEdit">取消</el-button>
        <el-button type="primary" @click="saveFn">保存</el-button>
      </div>
    </el-dialog>
    <!-- 题型介绍 -->
    <el-dialog title="题型介绍" :visible.sync="introVisible" width="1000px" :before-close="handleCloseType">
      <el-table :data="introList" style="width: 100%" header-cell-class-name="tableHeaderStyle"
        border
        stripe>
        <!-- 表单答题题型 -->
        <template v-if="type === 1">
          <el-table-column prop="quizName" label="题型" width="200px">
            <template slot-scope="scope">
              <div v-if="!scope.row.isEditing">{{ scope.row.quizName }}</div>
              <el-input class="edit-input" v-else v-model="scope.row.quizName"></el-input>
            </template>
          </el-table-column>
          <el-table-column prop="description" label="描述">
            <template slot-scope="scope">
              <template v-if="!scope.row.isEditing">
                <div>{{ scope.row.description }}</div>
                <div>{{ scope.row.engDescription }}</div>
              </template>
              <template v-else>
                <el-input class="edit-input" v-model="scope.row.description"></el-input>
                <el-input class="edit-input" v-model="scope.row.engDescription"></el-input>
              </template>
            </template>
          </el-table-column>
          <el-table-column label="操作" width="180px">
            <template slot-scope="scope">
              <el-button v-if="!scope.row.isEditing"
                type="text"
                icon="el-icon-edit"
                size="small"
                @click="editFn(scope.row)"
                >修改</el-button
              >
              <template v-else>
                <el-button type="primary" size="mini" @click="saveTypeFn(scope.row)">保存</el-button>
                <el-button type="primary" plain size="mini" @click="cancelTypeFn(scope.row)">取消</el-button>
              </template>
            </template>
          </el-table-column>
        </template>

        <!-- 练习题题型 -->
        <template v-if="type === 3">
          <el-table-column prop="quizName" label="题型" width="180px">
            <template slot-scope="scope">
              <div>{{ scope.row.quizName }}</div>
              <div>{{ scope.row.quizEngName }}</div>
            </template>
          </el-table-column>
          <el-table-column prop="quizOutsideUrl" label="古字形" width="180px">
            <template slot-scope="scope">
              <img :src="scope.row.quizOutsideUrl" class="guzixing" alt="">
            </template>
          </el-table-column>
          <el-table-column prop="quizPicUrl" label="古字形2" width="180px">
            <template slot-scope="scope">
              <img :src="scope.row.quizPicUrl" class="guzixing" alt="">
            </template>
          </el-table-column>
          <el-table-column prop="description" label="描述">
            <template slot-scope="scope">
              <div class="desc">
                {{ scope.row.description }}
              </div>
            </template>
          </el-table-column>
        </template>
      </el-table>
    </el-dialog>
  </div>
</template>
<script>
export default {
  data () {
    return {
      dataList: [],
      total: 0,
      queryForm: {
        activityType: this.$chnEngStatusCode.activityType,
        pageNum: 1,
        pageSize: 30,
        quizId: ''
      },
      type: '', // 1表单答题  2现场答题 3练习题
      typeStr: '',
      playing: false,
      formName: '',
      editVisible: false,
      editForm: {
        id: '',
        answer: '',
        choice: '',
        questionScore: 0,
        quizId: '',
        quizNumber: 0
      },
      editFormRules: {
        answer: [{ required: true, message: '请输入', trigger: 'blur' }],
        choice: [{ required: true, message: '请输入', trigger: 'blur' }],
        questionScore: [{ required: true, message: '请输入', trigger: 'blur' }],
        quizNumber: [{ required: true, message: '请输入', trigger: 'blur' }]
      },
      choiceList: [],
      isImgOption: '',
      editChoiceItem: '', // 一个选项
      editChoiceIndex: -1,
      introList: [],
      introVisible: false,
      isEditing: false,
      haveEditType: false,
      formInfo: {}, // 表单携带参数
      previewImgVisible: false, // 图片预览弹窗
      previewImgUrl: '' // 当前预览图片地址
    }
  },
  watch: {
    dataList: function () {
      this.$nextTick(() => {
        this.$forceUpdate()
      })
    }
  },
  created () {
    this.queryForm.quizId = this.$route.query.id
    this.formName = this.$route.query.paper
    this.type = Number(this.$route.query.type)
    this.typeStr = this.type === 1 ? '自定义试卷线上答题' : this.type === 2 ? '现场答题' : '练习题'
    this.formInfo = JSON.parse(this.$route.query.formInfo)
    this.getList()
  },
  methods: {
    goBack () {
      this.$router.push(`/academic_Management/paper?type=${this.type}`)
    },
    getList () {
      const url = this.type === 1 ? 'formQuiz/queryFromQuizInfoPage' : this.type === 2 ? '' : this.type === 3 ? 'quiz/queryQuizInfoPage' : ''
      const params = { ...this.queryForm, ...this.formInfo }
      if (!url) return
      this.$http.get(url, { params }).then(res => {
        if (res.code === 200) {
          this.total = res.data.total
          this.dataList = res.data.list
          this.dataList.forEach(item => {
            // 选项
            if (item.choice.includes('http')) {
              item.choiceType = 1
            } else {
              item.choiceType = 2
            }
            item.choiceList = item.choice.split(',')
            // 答案
            item.answerList = item.answer.split(',')
          })
        }
      })
    },
    handleCurrentChange (e) {
      this.queryForm.pageNum = e
      this.getList()
    },
    handleSizeChange (e) {
      this.queryForm.pageSize = e
      this.getList()
    },
    controlFn (url, item) {
      if (this.playing) {
        this.pause()
      } else {
        this.play(url)
      }
    },
    play (url) {
      if (this.playing) return
      this.playing = true
      this.$refs.audioPlayer.src = url
      this.$refs.audioPlayer.play()
    },
    // 点击缩略图预览大图
    handlePreviewImg (url) {
      if (!url) return
      this.previewImgUrl = url
      this.previewImgVisible = true
    },
    pause () {
      this.playing = false
      this.$refs.audioPlayer.pause()
    },
    handleToEdit (item) {
      this.editForm = {
        id: item.id,
        answer: item.answer,
        choice: item.choice,
        questionScore: item.questionScore,
        quizId: item.quizId,
        quizNumber: item.quizNumber
      }
      this.isImgOption = item.choice.includes('http')
      this.choiceList = item.choice.split(',')
      this.editChoiceItem = ''
      this.editChoiceIndex = -1
      this.editVisible = true
      // console.log(this.choiceList)
    },
    handleCloseEdit () {
      this.editVisible = false
      this.choiceList = []
      this.editChoiceItem = ''
      this.editChoiceIndex = -1
      this.isImgOption = false
    },
    saveFn () {
      this.$refs.editFormRef.validate(async valid => {
        if (!valid) return
        this.$http.post('formQuiz/updateFormQuizInfo', this.editForm).then(res => {
          if (res.code === 200) {
            this.$message.success('保存成功')
            this.getList()
            this.editVisible = false
          }
        })
      })
    },
    clickChoiceFn (item, index) {
      this.editChoiceItem = item
      this.editChoiceIndex = index
    },
    changeChoiceFn () {
      // this.choiceList[this.editChoiceIndex] = this.editChoiceItem
      this.choiceList.splice(this.editChoiceIndex, 1, this.editChoiceItem)
      this.editForm.choice = this.choiceList.join(',')
      this.editChoiceItem = ''
      this.editChoiceIndex = -1
    },
    showDialogIntro () {
      const url = this.type === 1 ? 'formQuiz/queryFromQuizTypeList' : this.type === 3 ? 'quiz/queryQuizTypeList' : ''
      this.$http.get(url, { params: this.formInfo }).then(res => {
        if (res.code === 200) {
          this.introVisible = true
          this.introList = res.data
          if (this.type === 3) {
            this.introList.forEach(item => {
              item.description = this.formatStr(item.description)
            })
          }
        }
      })
    },
    formatStr (str) {
      return str.includes('\\n') ? str.replaceAll('\\n', '\n') : str
    },
    editFn (item) {
      const index = this.introList.findIndex(intro => intro.id === item.id)
      this.$set(this.introList, index, { ...item, ...{ isEditing: true } })
    },
    cancelTypeFn (item) {
      const index = this.introList.findIndex(intro => intro.id === item.id)
      this.$set(this.introList, index, { ...item, ...{ isEditing: false } })
    },
    saveTypeFn (item) {
      console.log(item)
      this.$http.post('formQuiz/updateFromQuizType', {
        description: item.description,
        engDescription: item.engDescription,
        id: item.id,
        quizName: item.quizName
      }).then(res => {
        if (res.code === 200) {
          this.$message.success('修改成功')
          this.cancelTypeFn(item)
          this.haveEditType = true
        }
      })
    },
    handleCloseType () {
      this.introVisible = false
      if (this.haveEditType) { // 修改后刷新
        this.getList()
        this.haveEditType = false
      }
    }
  }
}
</script>
<style scoped lang="less">
.choice-text{
  display: block;
  float: left;
  min-width: 20px;
  height: 24px;
  text-align: center;
  line-height: 24px;
  margin: 4px;
  border: 1px solid #409EFF;
  border-radius: 4px;
  font-size: 14px;
  color: #000;
  padding-left: 2px;
  padding-right: 2px;
}
.choice-img{
  width: 32px;
  height: 32px;
  padding-top: 1px;
  margin-right: 8px;
  border: 1px solid #409EFF;
  border-radius: 4px;
  text-align: center;
  display: inline-block;
  img{
    height: 28px;
    width: auto;
  }
}
.refresh{
  color: #409EFF;
  cursor: pointer;
  margin-left: 12px;
}
.play-audio{
  width: 40px;
  height: 40px;
  border-radius: 100%;
  padding: 0;
}
.title{
  margin-bottom: 24px;
  border-bottom: 1px solid #DCDFE6;
  padding-bottom: 8px;
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.tip-text{
  font-size: 12px;
  color: #999;
  line-height: 22px;
}
.footer{
  text-align: center;
}
.choice-item{
  margin-bottom: 10px;
  cursor: pointer;
}
.desc{
  white-space: pre-line;
}
.guzixing{
  height: 100px;
}
.formName{
  color: #409EFF;
  font-weight: bold;
  font-size: 18px;
  margin-right: 4px;
}
.edit-input{
  margin-bottom: 10px;
  &:last-child{
    margin-bottom: 0;
  }
}
/* 题目图片缩略图（约 80rpx 大小） */
.quiz-img-thumb{
  width: 40px;
  height: 40px;
  object-fit: contain;
  cursor: pointer;
  border-radius: 4px;
}
.quiz-img-preview{
  max-width: 100%;
  max-height: 500px;
  object-fit: contain;
}
</style>
